import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const A: React.FC = () => {
    const { t } = useLang('ats.A');
    const { locale = '' } = useRouter();
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const st = setTimeout(() => {
                setEnter(true);
            }, 1000);
            return () => {
                clearTimeout(st);
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} smart-gateway-A GtmModuleData-section`}
            id="smart-gateway-A"
            data-section-id={'smart-gateway-A'}
            data-section-title={t('title')}
        >
            <div className="img pc">
                <picture>
                    <source srcSet={'https://websiteoss.ecoflow.com/upload/image/1760097744085/pc_kv.webp'} type="image/webp" />
                    <img
                        fetchpriority="high"
                        loading="eager"
                        src={'https://websiteoss.ecoflow.com/upload/image/1760097713661/pc_kv.jpg'}
                        alt={t('title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className="img h5">
                <picture>
                    <source srcSet={'https://websiteoss.ecoflow.com/upload/image/1760097744318/m_kv.webp'} type="image/webp" />
                    <img
                        fetchpriority="high"
                        loading="eager"
                        src={'https://websiteoss.ecoflow.com/upload/image/1760097714115/m_kv.jpg'}
                        alt={t('title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className={`info ${enter ? 'enter' : ''}`}>
                <div className={`inner`}>
                    <div className={`label ani-1 ${enter ? ' enter' : ''}`}>{t('label')}</div>
                    <div className={`title ani-2 ${enter ? ' enter' : ''}`}>{t('title')}</div>
                    <p className={`desc ani-3 ${enter ? ' enter' : ''}`}>{t('desc')}</p>
                </div>
            </div>
            {locale === 'ca' && <p className={`footer_text ani-3-5 ${enter ? ' enter' : ''}`}>{t('footer_text')}</p>}
        </section>
    );
};

export default A;
